import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../Select/Select';
import { useMvpPartners } from '../../hooks/useMvpPartners';

interface RetailerSelectProps {
  value?: string;
  onChange?: (value: string) => void;
  required?: boolean;
}

export const RetailerSelect: React.FC<RetailerSelectProps> = (props) => {
  const { value: externalValue, onChange, required = false } = props;
  const { t } = useTranslation('appointments');
  // Use internal state to track the selected value
  const [selectedValue, setSelectedValue] = useState<string | undefined>(externalValue);
  const { retailerOptions, isLoading, isError, error } = useMvpPartners();
  const placeholder = t('form.additionalInfo.retailerPlaceholder');

  // Update internal state when external value changes
  useEffect(() => {
    if (externalValue !== undefined) {
      setSelectedValue(externalValue);
    }
  }, [externalValue]);

  if (isError) {
    console.error('Error fetching retailers:', error);
  }

  return (
    <Select
      value={selectedValue}
      onChange={(value) => {
        setSelectedValue(value); // Update internal state
        onChange?.(value); // Notify parent component
      }}
      required={required}
      options={retailerOptions}
      placeholder={isLoading ? 'Loading retailers...' : placeholder}
      isDisabled={isLoading || isError}
    />
  );
};
